const getSeriesColorByLegendIndex = (legendIndex, colors) => {
    return legendIndex < colors.length ? colors[legendIndex] : colors[legendIndex % colors.length];
};
exports.getSeriesColorByLegendIndex = getSeriesColorByLegendIndex;
